/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Consent_TitleInputs */

const en_cookies_consent_title = /** @type {(inputs: Cookies_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use cookies`)
};

const pl_cookies_consent_title = /** @type {(inputs: Cookies_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używamy plików cookie`)
};

/**
* | output |
* | --- |
* | "We use cookies" |
*
* @param {Cookies_Consent_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_consent_title = /** @type {((inputs?: Cookies_Consent_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Consent_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_consent_title(inputs)
	return en_cookies_consent_title(inputs)
});